import http from "../common/request";

class RegisterCoachHighSchoolService {
  async register(model) {
    return http.post('/register/coach_high_school', model);
  }
}

export default new RegisterCoachHighSchoolService();